import { fetchLib, getJson, getStatus } from 'utils';
import { SERVICE_URL } from '../constants';

export const parseInvoiceService = async (Authorization, files) => {
  const formPayload = new FormData();

  files.forEach((file) => {
    formPayload.append('file', file);
  });

  const options = {
    method: 'POST',
    headers: {
      Authorization,
    },
    body: formPayload,
  };

  const response = await fetchLib(`${SERVICE_URL}api/parse-invoice`, options);
  const status = getStatus(response);
  const data = await getJson(response);

  return {
    status,
    data,
  };
};
